import React from 'react';
import { GridColumnMenuFilter, GridColumnMenuProps, GridColumnMenuSort } from '@progress/kendo-react-grid';
import { GridColumnMenuCheckboxFilterWrapper } from './GridColumnMenuCheckboxFilterWrapper';
import { GearFacetValue } from '../../../Model/GearFacets';
import { gridFilterOperators } from '../../../config/gridFilterOperators';
import { CompositeFilterDescriptor, FilterDescriptor } from '@progress/kendo-data-query';
import { NumericColumnMenuFilter } from './NumericColumnMenuFilter';
import { BulkColumnMenuFilter } from './BulkColumnMenuFilter';

interface ColumnMenuProps extends GridColumnMenuProps {
  field: string;
  fieldFacets: GearFacetValue[] | undefined;
  isNumericColumn?: boolean;
  supportsBulkFilter?: boolean;
}

export const ColumnMenu: React.FC<ColumnMenuProps> = props => {
  const { field, fieldFacets, filter, isNumericColumn, sortable, supportsBulkFilter } = props;
  const [filterExpanded, setFilterExpanded] = React.useState<boolean>(false);

  React.useEffect(() => {
    const activeFilter = filter?.filters.some(f1 =>
      (f1 as CompositeFilterDescriptor).filters.some(f2 => (f2 as FilterDescriptor).field === field)
    );
    if (activeFilter && !filterExpanded) {
      setFilterExpanded(true);
    }
  }, [field, filter, filterExpanded]);

  return (
    <div>
      {sortable && <GridColumnMenuSort {...props} />}
      {supportsBulkFilter ? (
        <BulkColumnMenuFilter {...props} field={field} expanded={filterExpanded} onExpandChange={setFilterExpanded} />
      ) : fieldFacets ? (
        <GridColumnMenuCheckboxFilterWrapper
          {...props}
          field={field}
          fieldFacets={fieldFacets}
          expanded={filterExpanded}
          onExpandChange={setFilterExpanded}
        />
      ) : (
        <GridColumnMenuFilter
          {...props}
          hideSecondFilter={true}
          filterOperators={gridFilterOperators}
          expanded={filterExpanded}
          onExpandChange={setFilterExpanded}
          filterUI={isNumericColumn ? NumericColumnMenuFilter : undefined}
          filterable={true}
        />
      )}
    </div>
  );
};
